interface PostcodeResponse {
  success: boolean;
  street: string;
  city: string;
  error: string;
}

export default function initGlobalJS() {
  const objectPosition = document.querySelectorAll<HTMLElement>('.js-object-position');
  const isTouchDevice = /iPad|iPhone|iPod|Android/.test(navigator.userAgent);
  objectPosition.forEach((el) => {
    const { objectPositionMobile } = el.dataset;
    el.style.setProperty('object-position', (objectPositionMobile && isTouchDevice)
      ? objectPositionMobile
      : el.dataset.objectPosition as string);
  });

  document.addEventListener('focusout', (event: Event) => {
    let postalCode = null;
    let addressLine2 = null;
    // @ts-ignore
    if (event.target.classList.contains('address-postal-code')) {
      postalCode = event.target as HTMLInputElement;
      addressLine2 = document.getElementById(postalCode.id.replace('postalCode', 'addressLine2')) as HTMLInputElement;
    }
    // @ts-ignore
    if (event.target.classList.contains('address-line-2')) {
      addressLine2 = event.target as HTMLInputElement;
      postalCode = document.getElementById(addressLine2.id.replace('addressLine2', 'postalCode')) as HTMLInputElement;
    }
    if (postalCode) {
      const postalCodeId = postalCode.id;
      const countryCode = document.getElementById(postalCodeId.replace('postalCode', 'countryCode')) as HTMLSelectElement;
      const postalCodeError = document.getElementById(`${postalCodeId}Error`);
      if (countryCode && postalCodeError) {
        const country = countryCode.value;
        const postcode = postalCode.value;
        const addressLine1 = document.getElementById(postalCodeId.replace('postalCode', 'addressLine1')) as HTMLInputElement;
        const locality = document.getElementById(postalCodeId.replace('postalCode', 'locality')) as HTMLInputElement;
        if (!Craft.validateZipCode(postcode, country)) {
          postalCode.classList.add('invalid');
          postalCodeError.textContent = window.GLOBAL_TRANSLATES.invalid_zip;
        } else {
          postalCode.classList.remove('invalid');
          postalCodeError.textContent = '';
          if (country === 'NL') {
            if (addressLine2 && addressLine2.value) {
              Craft.fetchPostcodeData(postcode, addressLine2.value).then((data: PostcodeResponse) => {
                if (data && data.success) {
                  if (addressLine1) {
                    addressLine1.value = data.street;
                    const addressLine1Error = document.getElementById(`${addressLine1.id}Error`);
                    if (addressLine1Error) {
                      addressLine1Error.textContent = '';
                    }
                  }
                  if (data.city && locality) {
                    locality.value = data.city;
                    const localityError = document.getElementById(`${locality.id}Error`);
                    if (localityError) {
                      localityError.textContent = '';
                    }
                  }
                  postalCodeError.textContent = '';
                } else {
                  postalCodeError.textContent = window.GLOBAL_TRANSLATES.invalid_lookup;
                }
              });
            }
          }
        }
      }
    }
  });
}
